import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

const useFlag = (name) => {
  const [on, setOn] = useState(false);
  useEffect(() => {
    const h = (e) => setOn(!!e.detail);
    window.addEventListener(name, h);
    return () => window.removeEventListener(name, h);
  }, [name]);
  return on;
};

export const StaleBanner = () => {
  const stale = useFlag("api-stale");
  const retrying = useFlag("api-retrying");
  if (!stale && !retrying) return null;
  return (
    <div data-testid={stale ? "stale-data-banner" : "retrying-banner"} className="fixed left-1/2 top-2 z-[60] flex -translate-x-1/2 items-center gap-2 rounded-full border border-amber-300 bg-amber-50 px-4 py-1.5 text-xs font-medium text-amber-800 shadow">
      <RefreshCw className="h-3.5 w-3.5 animate-spin" />
      {stale ? "Data terakhir dipaparkan — pelayan sibuk, sedang dikemas kini…" : "Pelayan sibuk — mencuba semula secara automatik…"}
    </div>
  );
};
